import { render, staticRenderFns } from "./TimeMod.vue?vue&type=template&id=5ad6527b"
import script from "./TimeMod.vue?vue&type=script&lang=js"
export * from "./TimeMod.vue?vue&type=script&lang=js"
import style0 from "./TimeMod.vue?vue&type=style&index=0&id=5ad6527b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports